// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fL","header":"fM","overTitle":"fN","image":"fO","title":"fP","description":"fQ","email":"fR","button":"fS"};